import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Join } from 'web/components/common/modal';
import { initModal, pushModal } from 'shared/actions/modal.action';
import { startLoading, finishLoading } from 'shared/actions/loading.action';

import {
  setUser,
  startJoinData,
  finishJoinData,
  setJoinData,
  setJoinVerificationData,
  getCheckEmailRequest,
  getCheckNicknameRequest,
  getSendPhoneAuthRequest,
  getVerifyCodeRequest,
  postRegisterRequest,
} from 'shared/actions/auth.action';
import { postCoupon } from 'shared/actions/coupon.action';

@connect(
  (state, props) => ({
    auth: state.shared.auth,
    modal: state.shared.modal,
    coupon: state.shared.coupon.couponInfo,
  }),
  {
    initModal,
    pushModal,
    setUser,
    startJoinData,
    finishJoinData,
    setJoinData,
    setJoinVerificationData,
    getCheckEmailRequest,
    getCheckNicknameRequest,
    getSendPhoneAuthRequest,
    getVerifyCodeRequest,
    postRegisterRequest,
    postCoupon,
    startLoading,
    finishLoading,
  },
)
class JoinContainer extends Component {
  handleModal = (componentName = 'term') => {
    this.props.pushModal({
      type: 'UsallyDetail',
      data: {
        componentName,
      },
    });
  };

  componentDidMount() {
    this.props.startJoinData();
  }

  componentWillUnmount() {
    this.props.finishJoinData();
  }

  state = {
    username: '',
    password: '',
  };

  state = {
    height: '',
  };

  handleBlur = e => {
    // console.log(`handleBlur `, e.target.name);
    const key = e.target.name;
    const value = e.target.value;
    switch (key) {
      case 'username':
        this.verificationUsername();
        break;
      case 'password':
        this.verificationLength('password', 8);

        if (!value.trim().length) {
          this.props.setJoinVerificationData(
            {
              password: false,
            },
            { message: '비밀번호를 입력해주세요 (8자 이상)' },
          );
        } else if (value.trim().length >= 8) {
          this.props.setJoinVerificationData(
            {
              password: true,
            },
            { message: '' },
          );
        } else {
          this.props.setJoinVerificationData(
            {
              password: false,
            },
            { message: '비밀번호를 입력해주세요 (8자 이상)' },
          );
        }
        break;
      case 'nickname':
        this.verificationNickname();
        this.setState({ height: '450px' });
        break;
      // case 'phone':
      //   if (this.props.auth.join.verification.phone) break;
      //   this.sendVerificationNumber();
      //   break;
      case 'phoneCode':
        if (this.props.auth.join.verification.phoneCode) break;
        if (this.props.auth.join.phoneCode.length === 6) {
          this.comparePhoneCode();
        }

        break;
      default:
        // console.log(`handleBlur switch default`);
        break;
    }
  };

  handleChange = async e => {
    const key = e.target.name;
    const value = e.target.value;
    const { join } = this.props.auth;
    const { verification } = join;
    const vArr = ['username', 'nickname', 'password', 'phone', 'phoneCode'];
    const isVerification = vArr.findIndex(k => k === key);

    console.log({ key, value });
    if (isVerification >= 0 && typeof verification[key] === 'boolean')
      await this.props.setJoinVerificationData({
        [key]: null,
      });

    if (key === 'nickname' && value.length > 2)
      this.props.getCheckNicknameRequest(value);

    await this.props.setJoinData({
      [key]: value,
    });

    // if (key === 'name') this.verificationLength('name', 2);
    // if (key === 'username') this.verificationLength('username', 4);
    if (key === 'password') this.verificationLength('password', 8);
    if (key === 'phoneCode' && value.length === 6) {
      this.comparePhoneCode();
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    // console.log(`handleSubmit`);
    const { join, user } = this.props.auth;
    const { verification, ...rest } = join;
    const { nickname, username, password, phone } = join;

    if (
      !username.trim() ||
      !password.trim() ||
      !phone.trim() ||
      !nickname.trim()
    ) {
      let compareList = ['username', 'password', 'phone', 'nickname'];
      let list = compareList.filter(li => !join[li].trim());
      // console.log({ list });
      let data = {};
      list.forEach(li => (data[li] = false));

      this.props.setJoinVerificationData(
        {
          username: false,
        },
        { message: '값이 없습니다.' },
      );
      return;
      // return alert(`${list.map(li => ' ' + li)} 항목을 입력해 주세요.`);
    }

    const data = {
      marketing: user.marketing,
      nickname: rest.nickname,
      password: rest.password,
      phone: rest.phone,
      username: rest.username,
    };

    this.props.postRegisterRequest(data);
    this.props.initModal();

    /**
     * 쿠폰 팝업 노출 쿠폰받기 클릭시 가입하면
     * 쿠폰 포스트요청 아니면 걍 새로고침
     */
    // let queryString = [];
    // let couponCode = '';
    // queryString = location.search.split('=');
    // couponCode = queryString[1];
    // console.log('queryString', queryString, coupon.codeMD5);
    // if (location.search !== '') {
    //   history.push(location.search);
    //   setTimeout(() => {
    //     this.props.postCoupon(coupon.codeMD5);
    //   }, 1500);
    // } else {
    //   setTimeout(() => {
    //     window.location.reload();
    //   }, 1000);
    // }
  };

  verificationUsername = () => {
    const regExp = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z]?)*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;

    const { join = {} } = this.props.auth;
    const { username } = join;
    // console.log({ username });
    if (!username.trim()) {
      return this.props.setJoinVerificationData(
        {
          username: false,
        },
        { message: '이메일을 입력해주세요.' },
      );
    } else if (username.match(regExp) === null) {
      return this.props.setJoinVerificationData(
        {
          username: false,
        },
        { message: '이메일 형식이 아닙니다.' },
      );
    }
    this.props.getCheckEmailRequest(username);
  };
  verificationNickname = () => {
    const { join = {} } = this.props.auth;
    const { nickname } = join;
    // console.log('verificationNickname', { nickname });
    if (!nickname.trim())
      return this.props.setJoinVerificationData(
        {
          nickname: false,
        },
        { message: '닉네임을 입력해 주세요' },
      );
    // alert('nickname 을 입력해 주세요');
    this.props.getCheckNicknameRequest(nickname);
  };

  sendVerificationNumber = async () => {
    const { join = {} } = this.props.auth;
    const { phone } = join;
    // console.log({ phone });
    if (!phone.trim()) return alert('phone 번호를 입력해 주세요');
    await this.props.getSendPhoneAuthRequest({ phone, type: 'join' });
  };

  verificationLength = (key, length = 4) => {
    const { join } = this.props.auth;
    const { verification } = join;
    if (join[key].length >= length && verification[key] !== true)
      this.props.setJoinVerificationData({
        [key]: true,
      });
    else if (join[key].length < length && verification[key] === true)
      this.props.setJoinVerificationData({
        [key]: null,
      });
    else {
      this.props.setJoinVerificationData({
        [key]: null,
      });
    }
  };

  matchVertificationNumber = () => {};

  comparePhoneCode = callback => {
    const { join } = this.props.auth;
    const { phoneCode, phone } = join;

    // Todo: Compare Request
    // console.log({ phoneCode, phone });
    this.props.getVerifyCodeRequest({ phoneCode, phone, type: 'join' }, () => {
      if (typeof callback === 'function') {
        callback();
      }

      //this.props.popupHandler.hasEmail();
    });
  };

  handleLink = path => {
    this.props.finishJoinData();
    this.props.history.push(path);
  };

  handleUserNumber = () => {
    this.props.setJoinVerificationData({
      phoneCode: true,
    });
  };

  handleMarketing = () => {
    const { marketing } = this.props.auth.user;
    return this.props.setUser({ marketing: !marketing });
  };

  render() {
    const { join = {}, user = {} } = this.props.auth;
    const {
      nickname,
      password,
      username,
      phone,
      phoneCode,
      verification = {},
      error = {},
    } = join;

    const { marketing } = user;

    console.log({ verification });

    return (
      <Join
        modal={this.props.modal}
        marketing={marketing}
        username={username}
        password={password}
        nickname={nickname}
        phone={phone}
        phoneCode={phoneCode}
        verification={verification}
        error={error}
        handleChange={this.handleChange}
        handleBlur={this.handleBlur}
        handleSubmit={this.handleSubmit}
        handlePopup={this.props.popupHandler}
        handleMarketing={this.handleMarketing}
        sendVerificationNumber={this.sendVerificationNumber}
        setJoinVerificationData={this.props.setJoinVerificationData}
        handleModal={this.handleModal}
        getNickNameCheck={this.props.getCheckNicknameRequest}
      />
    );
  }
}

export default JoinContainer;
